
export default function Projects() {
  const projects = [
    {
      category: 'DIGITAL MEDIA',
      title: 'Digital Platform Systems',
      description: 'Web-based tools and automated publishing infrastructure supporting scalable distribution.&nbsp; ',
      image: 'https://public.readdy.ai/ai/img_res/83fd01bbcbe7f6ec7a19418492175423.jpg'
    },
    {
      category: 'SOFTWARE',
      title: 'Application Development',
      description: 'Browser-based software systems designed for operational efficiency and growth.',
      image: 'https://readdy.ai/api/search-image?query=web%20application%20development%20workspace%20showing%20code%20editor%20and%20browser%20testing%20environment%20with%20modern%20web%20app%20interface%20clean%20professional%20setup%20representing%20software%20development%20operations%20in%20corporate%20style%20with%20structured%20layout&width=600&height=600&seq=project-002&orientation=squarish'
    },
    {
      category: 'ASSET MANAGEMENT',
      title: 'Real Asset Operations',
      description: 'Long-term rental property holdings structured for cash flow stability and appreciation.',
      image: 'https://readdy.ai/api/search-image?query=modern%20residential%20rental%20property%20exterior%20view%20showing%20well%20maintained%20multi%20unit%20building%20with%20professional%20property%20management%20aesthetic%20clean%20architecture%20representing%20real%20estate%20investment%20portfolio%20in%20natural%20daylight&width=600&height=600&seq=project-003&orientation=squarish'
    }
  ];

  return (
    <section id="projects" className="bg-[#F5F5F0] py-32">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] mb-4 lg:mb-0">
            Portfolio Overview
          </h2>
          <p className="text-base text-gray-600 max-w-md">
            Showcasing operational diversity and technical execution
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5">
            <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer h-full">
              <div className="relative w-full" style={{ paddingBottom: '125%' }}>
                <img
                  src={projects[0].image}
                  alt={projects[0].title}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-transparent"></div>
              </div>
              <div className="p-8">
                <p className="text-xs font-semibold text-[#1A2B4A] tracking-widest uppercase mb-3">
                  {projects[0].category}
                </p>
                <h3 className="text-2xl font-bold text-[#1A2B4A] mb-3">
                  {projects[0].title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {projects[0].description}
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6">
            {projects.slice(1).map((project, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              >
                <div className="relative w-full" style={{ paddingBottom: '100%' }}>
                  <img
                    src={project.image}
                    alt={project.title}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-transparent"></div>
                </div>
                <div className="p-6">
                  <p className="text-xs font-semibold text-[#1A2B4A] tracking-widest uppercase mb-2">
                    {project.category}
                  </p>
                  <h3 className="text-xl font-bold text-[#1A2B4A] mb-2">
                    {project.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
